// import React from "react";


// const SimpleBanner = ({
//   title = "",
//   subheading = "",
// }) => {
//   return (
//     <div className="relative w-full h-[250px] md:h-[250px] lg:h-[300px] overflow-hidden py-6">
//       {/* Dark Gradient Background */}
//       <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
      
//       {/* Grid Pattern Overlay - Fixed Version */}
//       <div className="absolute inset-0 opacity-30">
//         <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
//           <defs>
//             <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
//               <path d="M 60 0 L 0 0 0 60" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
//             </pattern>
//           </defs>
//           <rect width="100%" height="100%" fill="url(#grid)"/>
//         </svg>
//       </div>
      
//       {/* Content */}
//       <div className="relative z-10 flex items-center justify-center h-full sm:px-6 text-center lg:mt-10 lg:mr-40">
//         <div className="w-auto">
//           <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-jakarta font-bold text-white leading-tight">
//             {title}
//           </h1>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SimpleBanner;



import React from "react";


const SimpleBanner = ({
  title = "",
  subheading = "",
}) => {
  return (
    <div className="relative w-full h-[250px] md:h-[200px]  overflow-hidden py-6">
      {/* Dark Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-200 via-gray-100 to-gray-300"></div>
      
      {/* Grid Pattern Overlay - Fixed Version */}
      <div className="absolute inset-0 opacity-30">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)"/>
        </svg>
      </div>
      
      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full sm:px-6  lg:mt-10 ">
        <div className="w-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-jakarta font-bold text-gray-700 leading-tight">
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default SimpleBanner;